<script>
  import {PATH_PREFIX} from '../../apiUrls.js';

  import Modal from '../Modal.svelte';
  import Button from '../Button.svelte';
  import { onMount } from 'svelte';
  import { validateForm } from '../Form/utils.js';
  import ComboSelect from '../ComboSelect/ComboSelect.svelte';
  import CheckBox from '../CheckBox.svelte';
  import yup, { object, number, string } from 'yup';
  import { submit } from '../Form/utils.js';
  import Errors from '../Errors.svelte';
  import TextInput from '../TextInput.svelte';
  import {get} from '../../utils.js';
  import {sgettext} from '../../i18n.js';
  import RelatedActivitiesDataTable from '../GlobalHazard/RelatedActivitiesDataTable.svelte';

  export let id = 'branchHazardControlForm';
  export let rrrEnabled = true;
  export let actionUrl = `${PATH_PREFIX}/sw/api/branchhazardscontrols/`;
  export let branchId = null;
  export let hazardOptionsUrl = `${PATH_PREFIX}/sw/api/applicable-hazards/`;
  export let controlOptionsUrl = `${PATH_PREFIX}/sw/api/applicable-controls/`;
  export let severityOptionsUrl = `${PATH_PREFIX}/sw/api/severity/`;
  export let likelihoodOptionsUrl = `${PATH_PREFIX}/sw/api/likelihood/`;

  export let mechanismOptionApi = `${PATH_PREFIX}/sw/api/mechanisms/`;
  export let getRiskIdApi =
    `${PATH_PREFIX}/sw/api/branchhazardscontrols/get_risk_id/?branch_id={0}&global_hazard_id={1}`;
  export let getControlIdApi =
    `${PATH_PREFIX}/sw/api/branchhazardscontrols/get_control_id/?branch_id={0}&global_control_id={1}`;

  let controlOwnersUrl = `${PATH_PREFIX}/sw/api/builder/branch/${branchId}/control-owners/options/`;

  export let title = sgettext('$$BRANCH_RISK_CONTROL$$');
  export let onSubmit = (data) => data;
  export let editId = 0;
  export let global_hazard_id = 0;
  export let global_control_id = 0;
  export let branch_id = 0;
  export let isEcmsBranch = false;
  export let ecmsMechanismId = -1;
  export let materialRiskFlag = false;
  export let controlOwnerId = 0;

  let selectedMechanism;
  let mechanismOptions = []
  let allHazardOptions = [];
  let hazardOptions = [];
  let controlOptions = [];
  let controlOwnerOptions = [];
  let allSeverities = [];
  let severityOptions = [];
  let allLikelihoods = [];
  let likelihoodOptions = [];
  let isValid = true;
  let sending = false;
  let formErrors = null;
  let requireReload = false;

  let selectedSeverity = null;
  let selectedLikelihood = null;

  let initialSeverity = null;
  let initialLikelihood = null;

  let showGRCCode = true;
  let isMaterialRiskDisabled = false;

  let branchHazardControl = getDefault();

  let schema = object().shape({
    global_hazard: number()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$')),
    global_control: number()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$')),
    risk_id: string()
      .nullable()
      .matches(/\b[1-9][0-9]{7}\b/, {
        excludeEmptyString: true,
        message: sgettext('$$INVALID_FORMAT_MUST_8_DIGIT_NUMBER$$'),
      }),
    control_id: string()
      .nullable()
      .matches(/\b[1-9][0-9]{7}\b/, {
        excludeEmptyString: true,
        message: sgettext('$$INVALID_FORMAT_MUST_8_DIGIT_NUMBER$$'),
      }),
    control_owner: number()
      .transform((value) => isNaN(value) ? null : value)
      .nullable(),
  });

  let fieldIsValid = getDefaultFieldIsValid();

  $: if (editId) {
    getEditItem();
  }

  function getDefaultFieldIsValid() {
    return {
      global_hazard: {
        isValid: true,
        errors: '',
      },
      global_control: {
        isValid: true,
        errors: '',
      },
      risk_id: {
        isValid: true,
        errors: '',
      },
      control_id: {
        isValid: true,
        errors: '',
      },
      control_owner: {
        isValid: true,
        errors: '',
      },
    };
  }

  function resetFormValidation(){
    isValid = true;
    formErrors = null;
  }

  async function handleHazardChanged(event) {
    if (event.detail.value) {
      await getRiskId(event.detail.value);
      await getControlOptions(controlOptionsUrl + event.detail.value + '/');
      resetFormValidation();
    }
  }

  async function fetchMaterialRiskStatus(bhcId) {
    let dataUrl = `${PATH_PREFIX}/sw/api/bhc-usage-in-activities/${bhcId}/material-risk-status/`;

    let resp = await get(dataUrl);
    resp = await resp.json();

    try {
        isMaterialRiskDisabled = resp["is_template_pending_approval"]
        if (isMaterialRiskDisabled) {
            branchHazardControl = {...branchHazardControl, material_risk_flag: materialRiskFlag}
        }
    } catch (err) {
        formErrors = err;
        console.error(err);
    }
  }

  $: if (editId) {
    fetchMaterialRiskStatus(editId);
  }

  async function handleControlChanged(event) {
    if (event.detail.value) {
      await getControlId(event.detail.value);
      resetFormValidation();
    }
  }

  function handleControlOwnerChanged(event) {
    if (event.detail.value) {
      branchHazardControl = { ...branchHazardControl, control_owner: Number(event.detail.value)};
      resetFormValidation();
    }
  }

  function toggleGRCCode() {
    showGRCCode = !showGRCCode;
  }
  
  // GRC code is hidden for non material risks
  $: showGRCCode = branchHazardControl.material_risk_flag

  async function onSaveAndClose() {
    try {
      await validateForm(schema, branchHazardControl);
      await submitForm();

      if (!formErrors || formErrors.length === 0) {
        jQuery('#' + id).modal('hide');
        branchHazardControl = getDefault();
        onSubmit();
      }
    } catch (err) {
      isValid = false;
      if (err.inner) {
        err.inner.forEach((er) => {
          fieldIsValid[er.path].isValid = false;
          fieldIsValid[er.path].errors = er.message;
        });
      }
    }
  }

  async function submitForm() {
    sending = true;
    let method = 'POST';
    let url = actionUrl;
    if (editId) {
      method = 'PUT';
      url = actionUrl + editId + '/';
    }

    try {
      await submit(url, method, branchHazardControl);
      sending = false;

      return true;
    } catch (error) {
      sending = false;

      if (error.hasOwnProperty('non_field_errors')) {
        formErrors = error;
      }

      return false;
    }
  }

  async function onSaveAndCreate() {
    // save but keep the selected hazard so user can add another control to the hazard
    sending = true;
    try {
      await validateForm(schema, branchHazardControl);
      let success = await submitForm();
      if (!formErrors || formErrors.length === 0 && success) {
        branchHazardControl = {
          ...getDefault(),
          global_hazard: branchHazardControl.global_hazard,
          risk_id: branchHazardControl.risk_id
        };
        requireReload = true;
        editId = null;
      }
    } catch (err) {
      isValid = false;
      err.inner.forEach((er) => {
        fieldIsValid[er.path].isValid = false;
        fieldIsValid[er.path].errors = er.message;
      });
    }

    sending = false;
  }

  function getDefault() {
    return {
      global_hazard: null,
      global_control: null,
      severity: null,
      likelihood: null,
      branch: branchId,
      residual_risk_rating: 0,
      risk_id: null,
      control_id: null,
      material_risk_flag: materialRiskFlag,
      control_owner: null,
    };
  }

  async function getEditItem() {
    if (editId) {
      const response = await get(actionUrl + editId + '/');
      const json = await response.json();

      if (json) {
        branchHazardControl = json;

        selectedMechanism = branchHazardControl.mechanism_id;

        if (branchHazardControl.global_hazard) {
          await getControlOptions(
            controlOptionsUrl + branchHazardControl.global_hazard + '/'
          );
        }

        initialSeverity = allSeverities.find((j) => {
          return j.id === branchHazardControl.severity;
        });

        initialLikelihood = allLikelihoods.find((j) => {
          return j.id === branchHazardControl.likelihood;
        });
      }
    }
  }

  async function getRiskId(hazard_id) {
    if (branchId && hazard_id) {
      const response = await get(
        getRiskIdApi.replace('{0}', branchId).replace('{1}', hazard_id)
      );
      const json = await response.json();

      if (json) {
        branchHazardControl.risk_id = json.risk_id;
      }
    }
  }

  async function getControlId(control_id) {
    if (branchId && control_id) {
      const response = await get(
        getControlIdApi
          .replace('{0}', branchId)
          .replace('{1}', control_id)
      );
      const json = await response.json();

      if (json) {
        branchHazardControl.control_id = json.control_id;
      }
    }
  }

  function handleClose() {
    branchHazardControl = getDefault();
    fieldIsValid = getDefaultFieldIsValid();
    isValid = true;
    formErrors = null;
    editId = null;
    selectedMechanism = null;

    filterHazards();

    if (requireReload) {
      onSubmit();
    }
  }

  async function getHazardOptions(url) {
    const response = await get(url);
    const json = await response.json();

    allHazardOptions = [...json];
    hazardOptions = [...json];
  }

  async function getControlOptions(url) {
    const response = await get(url);
    controlOptions = await response.json();

    // auto-select first control if it is the solitary option
    if (controlOptions.length === 1 && !editId) {
      branchHazardControl.global_control = controlOptions[0].id;
    }
  }

  async function getSeverityOptions(url) {
    const response = await get(url);
    const json = await response.json();

    allSeverities = json.map((j) => {
      return {
        ...j,
        name: j.sequence + ' - ' + j.name + ' (' + j.multiplier + ')',
      };
    });

    severityOptions = allSeverities.filter((j) => {
      return !j.legacy
    });

  }

  async function getLikelihoodOptions(url) {
    const response = await get(url);
    const json = await response.json();

    allLikelihoods = json.map((j) => {
      return {
        ...j,
        name: j.sequence + ' - ' + j.name + ' (' + j.multiplier + ')',
      };
    });

    likelihoodOptions = allLikelihoods.filter((j) => {
      return !j.legacy;
    });
  }

  async function getControlOwnerOptions(url) {
      const response = await get(url);
      if (response.ok) {
          const res = await response.json();
          controlOwnerOptions = res.map((r) => ({...r, fieldIsValid: getDefaultFieldIsValid()}));
      } else {
          const error = await response.json();
          if (error.hasOwnProperty('error')) {
            errors = error;
          }
      }
  }

  function clearControlOwnerSelection() {
    branchHazardControl = { ...branchHazardControl, control_owner: null }
  }

  function calculateResidualRisk(event) {
    let residual_risk_rating = '';

    if (selectedLikelihood && selectedSeverity) {
      residual_risk_rating =
        selectedSeverity.multiplier * selectedLikelihood.multiplier;
      if (residual_risk_rating) {
        branchHazardControl.residual_risk_rating = Number(residual_risk_rating.toFixed(2));
      }
    }
  }

  async function getMechanisms(url) {
    const response = await get(url);
    mechanismOptions = await response.json();
  }

  async function filterHazards() {
    // On change of mechanism:
    // 1. clear selected hazard
    // 2. clear selected control
    // 3. clear control options
    // 4. filter hazard options based ono selected mechanism
    // 5. auto select hazard and control if there is only one option for the selected mechanism

    branchHazardControl.global_hazard = null;
    branchHazardControl.global_control = null;
    controlOptions = [];

    if (selectedMechanism) {
      hazardOptions = [...allHazardOptions.filter(x => x.id === selectedMechanism)];

      // auto-select first hazard if there it is the solitary option
      if (!editId && hazardOptions.length === 1 && hazardOptions[0].global_hazards.length === 1) {
        let firstHazard = hazardOptions[0].global_hazards[0]
        branchHazardControl.global_hazard = firstHazard.id;

        await getControlOptions(controlOptionsUrl + firstHazard.id + '/');
      }

    } else {
      hazardOptions = [...allHazardOptions];
    }

    resetFormValidation();
  }

  async function prefillEcmsFields() {
    if (isEcmsBranch && !editId) {
      selectedMechanism = ecmsMechanismId;
      filterHazards();
    }
  }

  onMount(async () => {
    await getMechanisms(mechanismOptionApi);
    await getHazardOptions(hazardOptionsUrl);
    await getSeverityOptions(severityOptionsUrl);
    await getLikelihoodOptions(likelihoodOptionsUrl);
    await getControlOwnerOptions(controlOwnersUrl);

    // if (isEcmsBranch && !editId) {
    //   selectedMechanism = ecmsMechanismId;
    //   await filterHazards();
    // }

    branchHazardControl = {...branchHazardControl, material_risk_flag: materialRiskFlag}

    jQuery('#' + id).on('hidden.bs.modal', function() {
      handleClose();
    });

    jQuery('#' + id).on('shown.bs.modal', function() {
      prefillEcmsFields();
    });
  });
</script>

<Modal {id} {title} backdrop={'static'} extraLarge={true}>
  <div slot="body">
    <form>
      <div class="form-group d-flex">
        <div class="mr-2">
          <label>
            {sgettext('$$FILTER_ENERGY$$')}
            <span class="text-secondary"
              >{sgettext('$$SELECT_RISKCONTROL$$')}</span
            >
          </label>
        </div>
        <div style="width: 100%" data-testid="filter-energy">
          <ComboSelect
            id="mechanism_id"
            label={''}
            options={mechanismOptions}
            children="mechanisms"
            on:changed={filterHazards}
            bind:value={selectedMechanism}
            required="true"
            searchable={true}
          />
        </div>
      </div>

      <div class="form-group" data-testid="risk">
        <ComboSelect
          id="global_hazard"
          label={sgettext('$$RISK_1$$')}
          bind:options={hazardOptions}
          children="global_hazards"
          bind:value={branchHazardControl.global_hazard}
          bind:isValid={fieldIsValid.global_hazard.isValid}
          bind:errors={fieldIsValid.global_hazard.errors}
          on:changed={handleHazardChanged}
          searchable={true}
          {schema}
        />
      </div>
      <div class="form-group" data-testid="control">
        <ComboSelect
          id="global_control"
          label={sgettext('$$CONTROL_1$$')}
          bind:options={controlOptions}
          bind:value={branchHazardControl.global_control}
          bind:isValid={fieldIsValid.global_control.isValid}
          bind:errors={fieldIsValid.global_control.errors}
          on:changed={handleControlChanged}
          searchable={true}
          {schema}
        />
      </div>

      <div class="form-row" class:d-none={!rrrEnabled}>
        <div class="form-group col-md-6" data-testid="severity">
          <ComboSelect
            id="severity"
            label={sgettext('$$SEVERITY$$')}
            bind:options={severityOptions}
            bind:value={branchHazardControl.severity}
            bind:selected={selectedSeverity}
            on:changed={calculateResidualRisk}
          />
        </div>
        <div class="form-group col-md-6" data-testid="likelihood">
          <ComboSelect
            id="likelihood"
            label={sgettext('$$LIKELIHOOD$$')}
            options={likelihoodOptions}
            bind:selected={selectedLikelihood}
            bind:value={branchHazardControl.likelihood}
            on:changed={calculateResidualRisk}
          />
        </div>
      </div>

      {#if (initialSeverity && initialSeverity.legacy) || (initialLikelihood && initialLikelihood.legacy)}
        <div class="form-row">
          <div class="form-group col-md-6">
            {#if initialSeverity && initialSeverity.legacy}
              {sgettext('$$LEGACY$$')}: {initialSeverity.name}
            {/if}
          </div>
          <div class="form-group col-md-6">
            {#if initialLikelihood && initialLikelihood.legacy}
              {sgettext('$$LEGACY$$')}: {initialLikelihood.name}
            {/if}
          </div>
        </div>
      {/if}
      <div class="form-group">
        <label>{sgettext('$$RESIDUAL_RISK$$')}:</label>
        {#if branchHazardControl.residual_risk_rating}
          <span class="residual-risk">
            {branchHazardControl.residual_risk_rating.toFixed(2)}
          </span>
        {/if}
      </div>
      <div class="form-group" data-testid="material-risk">
        <CheckBox
          id="material_risk_flag"
          label={sgettext('$$MATERIAL_RISK_1$$')}
          bind:checked={branchHazardControl.material_risk_flag}
          disabled={isMaterialRiskDisabled}
          tooltip={isMaterialRiskDisabled
            ? sgettext(
                '$$MATERIAL_RISK_CHECKBOX_CANNOT_CHANGED$$'
              )
            : ''}
        />
      </div>

      {#if editId}
        <div class="mt-4">
          <RelatedActivitiesDataTable branchHazardControlId={editId} />
        </div>
      {/if}

      <div class="mt-3 text-link" on:click={toggleGRCCode}>
        {sgettext('$$CLICK_1$$')}
        {showGRCCode ? sgettext('$$HIDE$$') : sgettext('$$SHOW$$')}
        {sgettext('$$GRC_CODE$$')}
      </div>

      <div class="form-row" class:hidden={!showGRCCode} data-testid="material-risk-container">
        <div class="form-group col-md-6" data-testid="second-risk">
          <TextInput
            id="risk_id"
            label={sgettext('$$RISK_2$$')}
            bind:isValid={fieldIsValid.risk_id.isValid}
            bind:errors={fieldIsValid.risk_id.errors}
            bind:value={branchHazardControl.risk_id}
            object={branchHazardControl}
            {schema}
          />
        </div>
        <div class="form-group col-md-6" data-testid="second-control">
          <TextInput
            id="control_id"
            label={sgettext('$$CONTROL_2$$')}
            bind:isValid={fieldIsValid.control_id.isValid}
            bind:errors={fieldIsValid.control_id.errors}
            bind:value={branchHazardControl.control_id}
            object={branchHazardControl}
            {schema}
          />
        </div>
      </div>
      {#if branchHazardControl.material_risk_flag}
        <div data-testid="control-owner-container">
          <a class="float-right" href="#" on:click={clearControlOwnerSelection}
            >{sgettext('$$CLEAR$$')}</a
          >
          <ComboSelect
            id="control_owner"
            label={sgettext('$$CONTROL_OWNER$$')}
            searchPlaceholderText={sgettext(
              '$$CLICK_SELECT_ADD_CONTROL_OWNER_$$'
            )}
            bind:isValid={fieldIsValid.control_owner.isValid}
            bind:errors={fieldIsValid.control_owner.errors}
            bind:value={branchHazardControl.control_owner}
            bind:options={controlOwnerOptions}
            on:changed={handleControlOwnerChanged}
            searchable={true}
            editable={true}
            object={branchHazardControl}
            {schema}
          >
            <i
              slot="labelIcon"
              class="fa fa-info-circle"
              style="color: #ccc;"
              title={sgettext("$$ADDING_CONTROL_OWNER_ENABLES_ROLE_RISK$$")}
            />
          </ComboSelect>
        </div>
      {/if}
    </form>
    {#if formErrors}
      <Errors errors={formErrors} />
    {/if}
  </div>

  <div slot="footer" class="footer">
    {#if !editId}
      <Button
        type="secondary"
        on:click={onSaveAndCreate}
        disabled={sending}
        name={sgettext('$$SAVE_CREATE_ANOTHER$$')}
      />
    {/if}
    <Button
      type="primary"
      on:click={onSaveAndClose}
      disabled={sending}
      name={sgettext('$$SAVE_CLOSE$$')}
    />
  </div>
</Modal>

<style>
  .residual-risk {
    font-size: 24px;
  }

  .text-input {
    height: 44px;
    width: 100%;
    border: 1px solid #dddddd;
    padding: 10px;
  }

  .text-link {
    color: #656565;
    cursor: pointer;
    margin-bottom: 0.5rem;
  }

  .text-link:hover {
    color: #dd5900;
  }

  .hidden {
    display: none;
  }

  .footer .btn {
    margin-left: 15px;
  }
</style>
